<template>

    <Page>

        <div class="grid grid-cols-1 md:grid-cols-2 items-center justify-around gap-x-2 gap-y-14 2xl:w-full">
        
            <Image src="/WhatIsCarbucks/summary-1.png"
                class="w-[80vw] md:w-full max-w-[800px] ml-auto" 
            />

            <Image src="/WhatIsCarbucks/summary-2.png"
                class="w-[80vw] md:w-full max-w-[800px] mr-auto" 
            />

        </div>
        
        <KeyMessage animation="push-up" class="-mt-2 2xl:-mt-6">
            Every interaction boosts loyalty, revenue &amp; goodwill
        </KeyMessage>

    </Page>

</template>